export default __webpack_public_path__ + "static/media/instagram.076b0d1a.svg";